import uniqby from "lodash.uniqby";
import moment from "moment";
import { UPDATE_FISHING_REPORT_DONE } from "../actions/reports";

const INITIAL_FISHING_REPORTS_STATE = [];

/*
// This is an example of what a fully completed fishing report should look like.
// `null` values represent fields that are optional.

const exampleFishingReport = {
  created_at: new Date(),
  updated_at: new Date(),
  submitted_at: new Date(), // could be null to represent an unsubmitted report
  is_approved: null,
  fishing_trip: {
    departure_datetime: new Date().toLocaleString(),
    departure_location: "",
    arrival_datetime: new Date().toLocaleString(),
    arrival_location: "",
    vessel_license_number: "",
    is_charter: true,
    crew_member: [
      {
        first_name: "",
        last_name: "",
        business_license_number: ""
      },
      {
        first_name: "",
        last_name: "",
        business_license_number: null
      }
    ],
    fishing_events: [
      {
        description: "",
        fishing_method_id: null,
				target_species: [],
        start_time: new Date().toLocaleString(),
        fishing_hours: 0,
        fished_areas_ids: "[]",
        catches: [
          {
            species_id: 0,
            total_count: 0,
            total_weight_lbs: 0.0,
            is_kept: true,
            attachments: [
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAKp2lDQ1BJQ0MgUHJvZmlsZQAASImVlgdYU1kWx+976Y2WUKWE3nsH6TX03myEJEAoISYEFbsyOIJjQUQElAEdqoKjUmQsiCAWBgEL9gEZFJRxsCAqKvuAJc7sfrv77cl3cn85Offcc+979/v+AJDvMfn8NFgKgHRepiDMx50eExtHx40ACOCQjypQYLKEfLeQkACA2OL4d3t/F8lG7JbxXK1///+/mjSbI2QBAIUgnMAWstIRPoN4O4svyAQAhTjQXJPJn+NihGkCpEGEj89x0gK3z3HCAt+ez4kI80B4DAA8mckUJAFAeofE6VmsJKQOmYawGY/N5SHsibAzK5nJRjgHYaP09Iw5PomwXsJf6iT9rWaCuCaTmSTmhb3MG96TK+SnMdf9n8fxvy09TbS4hibi5GSBb9jcOHduqRn+YuYlBAUvMpc9nz/PySLfyEVmCT3iFpnN9PQXz00LCljkRK43Q1wnkxGxyIKMMHF9jtArfJGZgm9riVIj3cTrchjimtnJEdGLnMWNClpkYWq4/7ccD3FcIAoT95wo8BbvMV34l31xGeL8zOQIX/Eemd964whjxD2wOZ5e4jgvUpzDz3QX1+enhYjzOWk+4rgwK1w8NxN52b7NDRGfTwrTL2SRgQ+wAFbABviCgEzO2rl3Gnhk8NcJuEnJmXQ35NZw6Awey8SIbmFmbg/A3B1ceMRv783fLUgO/y22YgAA031IsPBbLEMegA48spzwW0x/AgCJRAC6dFgiQdZCDD33hQFEIAloQBG535pADxgj3dkAR+AKvIAfCAYRIBasBCyQDNKBAKwBG8BWkAvywV5wAJSAcnAU1IAT4BRoAefAJXAF3AB94A54CIbAKHgJJsF7MANBEA6iQFRIEVKDtCFDyAKyg5whLygACoNioXgoCeJBImgDtB3KhwqgEqgCqoV+hs5Cl6BrUD90HxqGxqE30CcYBZNhGqwC68CmsB3sBvvDEfAKOAleDWfDOfBuuBiuhI/DzfAl+AZ8Bx6CX8JTKIAioeRQ6ihjlB3KAxWMikMlogSoTag8VBGqEtWAakN1o26hhlATqI9oLJqKpqON0Y5oX3QkmoVejd6E3oUuQdegm9Gd6FvoYfQk+iuGglHGGGIcMAxMDCYJswaTiynCVGGaMF2YO5hRzHssFiuH1cXaYn2xsdgU7HrsLuxhbCO2HduPHcFO4XA4RZwhzgkXjGPiMnG5uEO447iLuAHcKO4DnoRXw1vgvfFxeB5+G74IX4e/gB/AP8fPEKQI2gQHQjCBTVhH2EM4Rmgj3CSMEmaI0kRdohMxgphC3EosJjYQu4iPiG9JJJIGyZ4USuKStpCKSSdJV0nDpI9kGbIB2YO8nCwi7yZXk9vJ98lvKRSKDsWVEkfJpOym1FIuU55QPkhQJUwkGBJsic0SpRLNEgMSryQJktqSbpIrJbMliyRPS96UnJAiSOlIeUgxpTZJlUqdlRqUmpKmSptLB0unS++SrpO+Jj0mg5PRkfGSYcvkyByVuSwzQkVRNakeVBZ1O/UYtYs6SsPSdGkMWgotn3aC1kublJWRtZKNkl0rWyp7XnZIDiWnI8eQS5PbI3dK7q7cJ3kVeTd5jvxO+Qb5AflphSUKrgochTyFRoU7Cp8U6YpeiqmK+xRbFB8roZUMlEKV1igdUepSmlhCW+K4hLUkb8mpJQ+UYWUD5TDl9cpHlXuUp1RUVXxU+CqHVC6rTKjKqbqqpqgWql5QHVejqjmrcdUK1S6qvaDL0t3oafRieid9Ul1Z3VddpF6h3qs+o6GrEamxTaNR47EmUdNOM1GzULNDc1JLTStQa4NWvdYDbYK2nXay9kHtbu1pHV2daJ0dOi06Y7oKugzdbN163Ud6FD0XvdV6lXq39bH6dvqp+of1+wxgA2uDZINSg5uGsKGNIdfwsGG/EcbI3ohnVGk0aEw2djPOMq43HjaRMwkw2WbSYvLKVMs0znSfabfpVzNrszSzY2YPzWXM/cy3mbeZv7EwsGBZlFrctqRYeltutmy1fG1laMWxOmJ1z5pqHWi9w7rD+ouNrY3ApsFm3FbLNt62zHbQjmYXYrfL7qo9xt7dfrP9OfuPDjYOmQ6nHP50NHZMdaxzHFuqu5Sz9NjSEScNJ6ZThdOQM9053vlH5yEXdRemS6XLU1dNV7ZrletzN323FLfjbq/czdwF7k3u0x4OHhs92j1Rnj6eeZ69XjJekV4lXk+8NbyTvOu9J32sfdb7tPtifP199/kOMlQYLEYtY9LP1m+jX6c/2T/cv8T/aYBBgCCgLRAO9AvcH/goSDuIF9QSDIIZwfuDH4fohqwO+SUUGxoSWhr6LMw8bENYdzg1fFV4Xfj7CPeIPREPI/UiRZEdUZJRy6Nqo6ajPaMLoodiTGM2xtyIVYrlxrbG4eKi4qrippZ5LTuwbHS59fLc5XdX6K5Yu+LaSqWVaSvPr5JcxVx1Oh4THx1fF/+ZGcysZE4lMBLKEiZZHqyDrJdsV3Yhe5zjxCngPE90SixIHEtyStqfNJ7sklyUPMH14JZwX6f4ppSnTKcGp1anzqZFpzWm49Pj08/yZHipvM4M1Yy1Gf18Q34uf2i1w+oDqycF/oIqISRcIWzNpCFip0ekJ/pONJzlnFWa9WFN1JrTa6XX8tb2rDNYt3Pd82zv7J/Wo9ez1ndsUN+wdcPwRreNFZugTQmbOjZrbs7ZPLrFZ0vNVuLW1K2/bjPbVrDt3fbo7W05Kjlbcka+8/muPlciV5A7uMNxR/n36O+53/futNx5aOfXPHbe9Xyz/KL8z7tYu67/YP5D8Q+zuxN39+6x2XNkL3Yvb+/dfS77agqkC7ILRvYH7m8upBfmFb47sOrAtSKrovKDxIOig0PFAcWth7QO7T30uSS55E6pe2ljmXLZzrLpw+zDA0dcjzSUq5Tnl3/6kfvjvQqfiuZKncqio9ijWUefHYs61v2T3U+1VUpV+VVfqnnVQzVhNZ21trW1dcp1e+rhelH9+PHlx/tOeJ5obTBuqGiUa8w/CU6KTr74Of7nu6f8T3WctjvdcEb7TFkTtSmvGWpe1zzZktwy1Brb2n/W72xHm2Nb0y8mv1SfUz9Xel72/J4LxAs5F2YvZl+caue3T1xKujTSsarj4eWYy7c7Qzt7u/y7rl7xvnK526374lWnq+euOVw7e93uessNmxvNPdY9Tb9a/9rUa9PbfNP2ZmuffV9b/9L+CwMuA5dued66cptx+8adoDv9dyPv3htcPjh0j31v7H7a/dcPsh7MPNzyCPMo77HU46Inyk8qf9P/rXHIZuj8sOdwz9Pwpw9HWCMvfxf+/nk05xnlWdFztee1YxZj58a9x/teLHsx+pL/cmYi9w/pP8pe6b0686frnz2TMZOjrwWvZ9/seqv4tvqd1buOqZCpJ+/T389M531Q/FDz0e5j96foT89n1nzGfS7+ov+l7av/10ez6bOzfKaAOS8FUIjDiYg+eFMNACUWAGofAMRlCxp53qAFXT9P4D/xgo6eNxsAqrYAEOmKOPKzHGE9hCnIGIKMEa4AtrQU+z9NmGhpsVCL1IJIk6LZ2beINsTpA/BlcHZ2pmV29ksV0uwDANrfL2jzeR2DqEx41lPqUndfnO4H8C/2D/ZtB7LvHUvdAAACAmlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczpleGlmPSJodHRwOi8vbnMuYWRvYmUuY29tL2V4aWYvMS4wLyIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8ZXhpZjpQaXhlbFlEaW1lbnNpb24+MjU8L2V4aWY6UGl4ZWxZRGltZW5zaW9uPgogICAgICAgICA8ZXhpZjpQaXhlbFhEaW1lbnNpb24+MjU8L2V4aWY6UGl4ZWxYRGltZW5zaW9uPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KC0HzvwAAAzRJREFUSA3tlM1PXFUYxn935t75gJkOMAU6rRfaaS1twUbaqLAQoyuNdqWJcdONG3XbGLdNt/4J1Rg1cWVMaOKqbNqFqJFGCmlhLFDgCkOZ7zsf93t6IHYcMrRQkyYmelbn433P8z7P+5wjFfVynWc8fM/4/u3r/2MgniBdNSxM26Zef/oWyvvpSd31+O7aTWLRNl4aTNL/XA+Sb/9K7w0iKk+tpBm/tYg/EOTOWp4zfT2cH1BJqr0gSXvWKe1lYds2uXR1gh/XLGQBIptVlFKOs3GFd14e4M1XX+SAYPik8VgQ13W5MaMxPq/za8bAkRUCgRCekE4yKrjVPJXle7yeCHD5k/eId8WacLb69jfDXUFM22Fy+j6bkV70WDclbFa1TXTLR0dHJ1Ldo1yukV7RWJ28yUcjfVx89w1kWWY2dX/7bOTc6QZoS/dMy2F+KU1Xbw+jHTVSX10hqmucSfZgFjbwagUOdyq8cKKLsbFBzl24wN2sQSZbZPz6z3x+9Qfm7mkNgK1JC8jtuRUWtQwjAwnMUhZt5jf8RZ1oWMHSdVKi0lw2h2MatCk+hgb7cJIn+eybG3z65QSlik13vFk6aHGXJaQqlg2uTy0ydPwUX3z9LUtVmNJr+P0+dAFk1GoYVQXPMvEkH+FIiLxt4QYjhMM+ZBHXPHauxMno8AmGBYup6Xl+mlmh7g+ghlxUr4IsuUSFkzzPwxQAhmGgmGXUygahYoaSKRwYUgiFA80YrUwQj0wWxjCNAiGpl1yxRLxd4VTQZOxwO+W2TgKhIGGhQbtTw06vU0hvcOhAhJi9Qa3sFw7c+Su0yLVF7fljRzifLTA9t4CWL3P8yEFCAvkVtQtJCVCumRTyJZYWlrkz+wcfvv8WH188xvD3E0zeustmrrSDya4WfhSRWl7nl9klbi+sYjoekWgYxXPRtAc8ENV/8PZrnB3oRxXfTCwa2U5bXc/gOg5H1UOPrtlFrsYRnOxP0JfoZnTwKKWqiSMeqF98I7+L6q+t/UlQqjN0OtmUAWri4I711uKJTFqi/9qwLJv0Zp6waHJ3vPNxYY39fwTSyN7npMXC+8x7qrD/Qf59cj0EIypZGUzcIZIAAAAASUVORK5CYII= ",
            ],
            lost_to_predator: false,
            predator_species_id: null
          },
          {
            species_id: 0,
            total_count: 0,
            total_weight_lbs: 0.0,
            is_kept: false,
            lost_to_predator: false,
            predator_species_id: null
          },
          {
            species_id: 0,
            total_count: 0,
            total_weight_lbs: 0.0,
            is_kept: false,
            lost_to_predator: false,
            predator_species_id: null
          }
        ],
        sales_order: [
          {
            items: [
              {
                species_id: 0,
                total_count: 0,
                total_weight_lbs: 0.0,
                price_per_lb_usd: 0.0,
                sold_to_vendor: true,
                vendor_business_license_number: ""
              },
              {
                species_id: 0,
                total_count: 0,
                total_weight_lbs: 0.0,
                price_per_lb_usd: 0.0,
                sold_to_vendor: false,
                vendor_business_license_number: null
              }
            ]
          }
        ]
      }
    ]
  }
};
*/

export const initialFishingEventCatches = {
  species_id: null,
  total_count: null,
  total_weight_lbs: 0,
  is_kept: true,
  attachments: []
};

export const initialFishingEvent = {
  description: "",
  fishing_method_id: null,
  start_time: moment(new Date()).format("YYYY-MM-DDTHH:mm"),
  fishing_hours: 1,
  fished_areas_ids: "[]",
  target_species: [],
  number_of_gears: null,
  number_of_spears: null,
  catches: [{ ...initialFishingEventCatches }]
};

export const initialSaleState = {
  species_id: null,
  total_count: 0,
  total_weight_lbs: 0.0,
  price_per_lb_usd: 0.0,
  sold_to_vendor: true,
  vendor_business_license_number: ""
};

export const initialCrewMemberState = {
  first_name: "",
  last_name: "",
  business_license_number: ""
};

export const initialLostFishState = {
  species_id: null,
  total_count_lost: 0,
  total_weight_lbs_lost: null,
  lost_to_predator: null,
  predator_species_id: null,
  disposition: ""
};

export const initialState = {
  is_approved: null,
  submitted_at: null,
  departure_datetime: moment(new Date()).format("YYYY-MM-DDTHH:mm"),
  departure_location: "",
  arrival_datetime: moment(new Date()).format("YYYY-MM-DDTHH:mm"),
  arrival_location: "",
  vessel_license_number: "",
  is_charter: false,
  crew_member: [{ ...initialCrewMemberState }],
  fishing_events: [],
  sales_order: [
    {
      items: []
    }
  ],
  fish_lost: [],
  map_areas_id: null
};

/**
 *
 * @param {Array} currentState - Array of current reports on the app
 * @param {Array} updatedReports - Updated reports from the server
 *
 * return {Array} - Returns an array of unqiue (by id) reports
 *
 * If a report is created offline, it will be given a unique local id that will be removed before actually submitted
 *
 * If a report has been submitted, it will have a unique id given by the report server
 *
 * If a report was created on the backend and the device goes offline, the local instance will be preserved when the
 * user comes back online and fetches the user's reports
 */
function combineReports(currentState, updatedReports) {
  const submittedReports = updatedReports.filter(
    report => report.submitted_at !== null
  );
  let updatedState = [];
  updatedState = uniqby(
    [...submittedReports, ...currentState, ...updatedReports],
    "id"
  );
  return updatedState;
}

export default function fishingReportsReducer(
  state = INITIAL_FISHING_REPORTS_STATE,
  action = {}
) {
  switch (action.type) {
    case "GET_FISHING_REPORTS":
      return combineReports(state, action.payload.data);
    case "ADD_FISHING_REPORT":
      return [action.payload.report].concat(state);
    case "UPDATE_FISHING_REPORT":
      return state.map(fishingReport => {
        if (action.payload.revision.id === fishingReport.id) {
          return action.payload.revision;
        } else {
          return fishingReport;
        }
      });
    case "DELETE_FISHING_REPORT":
      return state.filter(fishingReport => {
        return fishingReport.id !== action.payload.id;
      });
    case UPDATE_FISHING_REPORT_DONE:
      return state.map(fishingReport => {
        if (action.payload.id === fishingReport.id) {
          return {
            ...fishingReport,
            done: true
          };
        } else {
          return fishingReport;
        }
      });
    default:
      return state;
  }
}
